import { SvgIconComponent } from '@mui/icons-material'
import LockIcon from '@mui/icons-material/Lock'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import ScannerIcon from '@mui/icons-material/Scanner'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import DescriptionIcon from '@mui/icons-material/Description'
import { FeatureFlagRoles, ReportRoles } from '@edge/spark/io-roles'

export interface SideBarLink {
    path: string
    text: string
    Icon: SvgIconComponent
    allowNotExact?: boolean
    testId?: string
    noAuth?: boolean
    allowAuctionAdmin?: boolean
    allowEdgeAdmin?: boolean
    singularRole?: FeatureFlagRoles
    showOnMobile?: boolean
    reportRoles?: ReportRoles[]
    ldFlag?: string
}

const navRoutes = (auctionId: string): SideBarLink[] => {
    return [
        {
            path: '/auction/reports',
            text: 'Reports',
            Icon: TrendingUpIcon,
            testId: 'reports-link',
            reportRoles: [ReportRoles.BASIC, ReportRoles.FINANCIALS],
            showOnMobile: true,
        },
        {
            path: '/auction/reportsv2',
            text: 'Reports',
            Icon: TrendingUpIcon,
            testId: 'reports-v2-link',
            reportRoles: [ReportRoles.BASIC, ReportRoles.FINANCIALS],
            showOnMobile: false,
        },
        {
            text: 'Admin',
            path: '/admin',
            testId: 'admin-link',
            Icon: LockIcon,
            allowAuctionAdmin: true,
            allowEdgeAdmin: true,
        },
        {
            text: 'Scanner',
            path: '/scanner',
            testId: 'scanner-link',
            Icon: ScannerIcon,
            singularRole: FeatureFlagRoles.VIEW_AND_MANAGE_DOCUMENTS,
            allowAuctionAdmin: false,
            allowEdgeAdmin: true,
            showOnMobile: false,
        },
        {
            text: 'Documents',
            path: '/documents/list',
            testId: 'documents-link',
            Icon: DescriptionIcon,
            allowEdgeAdmin: true,
            singularRole: FeatureFlagRoles.VIEW_AND_MANAGE_DOCUMENTS,
        },
        {
            path: `/auction/${auctionId}/fee-mgmt`,
            text: 'Fee Management',
            Icon: RequestQuoteIcon,
            testId: 'fee-management-link',
            allowEdgeAdmin: true,
            ldFlag: 'releaseFeeMgmt',
        },
    ]
}

export default navRoutes
